import { Component, OnInit } from '@angular/core'
import { ModalService } from '../../../../../services/modal.service'
import { FormBuilder, FormGroup } from '@angular/forms'

@Component({
    selector: 'app-modal-treatment',
    templateUrl: './modal-treatment.component.html',
    styleUrls: [
        '../../../../../stagingcss/root-ui-view.component.css',
        './modal-treatment.component.css'],
})
export class ModalTreatmentComponent implements OnInit {
    modalStatus = 'hidden'
    iprCount = 0
    iprCountCurrent = 0
    formTreatment: FormGroup
    treatmentOptions = []
    selectedOptions = {
        ipr: false,
        buttoncut: false,
        precisioncut: false,
    }

    stageTreatment = {}
    stageTreatmentIndex = 0
    totalNumber = 0

    constructor(private modalService: ModalService, private formBuilder: FormBuilder) {
        modalService.changeEmitted$.subscribe(
            success => {
                if (success.action === 'modalTreatmentActive') {
                    this.modalStatus = 'active'
                    this.stageTreatment = success.stageTreatment
                    this.stageTreatmentIndex = success.stageTreatmentIndex
                    this.treatmentOptions = success.treatmentOptions
                    this.totalNumber = success.totalNumber
                    this.updateForm(this.stageTreatment)
                    if (this.stageTreatment['treatmentOptions']) {
                        this.selectedOptions = jQuery.extend(true, {}, this.stageTreatment['treatmentOptions'])
                    } else {
                        this.selectedOptions = {
                            ipr: false,
                            buttoncut: false,
                            precisioncut: false,
                        }
                    }
                }
            })
    }

    ngOnInit() {
        this.initialForm()
    }

    closeModal() {
        this.modalStatus = 'hidden'
        this.iprCount = 0
        this.iprCountCurrent = 0
        this.selectedOptions = {
            ipr: false,
            buttoncut: false,
            precisioncut: false,
        }
        this.initialForm()
    }

    save() {
        const tmpStage = {}
        let key
        for (key in this.formTreatment.value) {
            if (this.formTreatment.value.hasOwnProperty(key) && this.formTreatment.value[key]) {
                tmpStage[key] = this.formTreatment.value[key]
            }
        }
        tmpStage['treatmentOptions'] = this.selectedOptions
        delete this.stageTreatment['treatmentOptions']
        delete this.stageTreatment['iprCount']
        delete this.stageTreatment['treatment']
        delete this.stageTreatment['buttoncut']
        delete this.stageTreatment['precisioncut']
        const returnStage = Object.assign(this.stageTreatment, tmpStage)
        const arrTreatment = {
            action: 'updatedTreatment',
            stageTreatment: returnStage,
            stageTreatmentIndex: this.stageTreatmentIndex,
        }
        this.modalService.emitChange(arrTreatment)
        this.closeModal()
    }

    toogleOptions(option) {
        if (this.selectedOptions[option]) {
            delete this.selectedOptions[option]
        } else {
            this.selectedOptions[option] = true
        }
    }

    initialForm() {
        this.formTreatment = this.formBuilder.group({
            iprCount: [0],
            treatment: [''],
            buttoncut: [''],
            precisioncut: [''],
        })
    }

    updateForm(data) {
        this.iprCount = data.iprCount || 0
        this.formTreatment.patchValue({
            iprCount: data.iprCount,
            treatment: data.treatment,
            buttoncut: data.buttoncut,
            precisioncut: data.precisioncut,
        })
    }

    prevRatio(iprCountCurent, day) {
        if ((parseInt(iprCountCurent) - parseInt(day)) > 0) {
            this.iprCount = parseInt(iprCountCurent) - parseInt(day)
        } else {
            this.iprCount = 0
        }
    }

    nextRatio(iprCountCurent, day) {
        if (parseInt(iprCountCurent) < 20) {
            this.iprCount = parseInt(iprCountCurent) + parseInt(day)
        } else {
            this.iprCount = 20
        }
    }

    changeIprCount(iprCountCurent) {
        if (iprCountCurent > 0) {
            this.iprCountCurrent = this.iprCount = parseInt(iprCountCurent)
        } else {
            this.iprCountCurrent = this.iprCount = 0
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/aligner/modal-treatment/modal-treatment.component.ts